var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickUbd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59192 8.47523C5.27228 8.9547 4.61461 9.06551 4.15551 8.71725L1.26073 6.52138C1.11674 6.41215 1.08858 6.20687 1.19783 6.0629C1.30706 5.91896 1.5123 5.89081 1.65625 6.00003L3.99669 7.7757C4.45579 8.12401 5.11351 8.01322 5.43317 7.53372L9.60738 1.27225C9.70762 1.12189 9.91077 1.08127 10.0611 1.18151C10.2115 1.28175 10.2521 1.48488 10.1519 1.63523L5.59192 8.47523Z",
    fill: "#003DA5",
    stroke: "#003DA5",
    strokeWidth: 0.666667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickUbd);
export default __webpack_public_path__ + "static/media/TickUBD.b3745a64aaceb012792dfa7ee77d3d73.svg";
export { ForwardRef as ReactComponent };